/* eslint-disable import/no-mutable-exports */
const env = process.env.REACT_APP_ENV;
let envValues = {
  PORT: 80,
  REACT_APP_API_ENDPOINT: 'http://localhost:4037/v1',
  REACT_APP_API_FRONT_END: 'http://localhost:4037',
  REACT_APP_API_PERMISSION_DENIED: 'http://localhost:4037/permission',
  REACT_APP_SHOW_COOKIE_BOX: false,
  SOCKET_STATUS: 'OFF',
  COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
  S3_PATH: 'https://orb-tatoo-bucket.s3.us-east-2.amazonaws.com/',
};
switch (env) {
  case 'staging':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://orbtatoo-api.iscriptsdemo.com/v1',
      REACT_APP_API_FRONT_END: 'https://manage-orbtattoo.iscriptsdemo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://manage-orbtattoo.iscriptsdemo.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_PATH: 'https://orb-tatoo-bucket.s3.us-east-2.amazonaws.com/',
    };
    break;
  case 'production':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api.orbtattoo.com/v1',
      REACT_APP_API_FRONT_END: 'https://manage.orbtattoo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://manage.orbtattoo.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_PATH: 'https://orb-tatoo-bucket.s3.us-east-2.amazonaws.com/',
    };
    break;
  case 'development':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4037/v1',
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      S3_PATH: 'https://orb-tatoo-bucket.s3.us-east-2.amazonaws.com/',
    };
    break;
  default:
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4037/v1',
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
}

export default envValues;
